import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaThreads, FaTiktok } from 'react-icons/fa6';
import './Footer.css';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <Link to="/" className="footer-brand" aria-label="LRM Management home">
            <img
              src={process.env.PUBLIC_URL + '/assets/lrm-menu.png'}
              alt="LRM Management"
              className="footer-logo"
            />
          </Link>
          <p className="footer-tagline">Where humor meets success</p>
        </div>

        <div className="footer-grid">
          <nav className="footer-column" aria-label="Footer navigation">
            <span className="footer-label">Navigate</span>
            <Link to="/">Home</Link>
            <Link to="/Comidians">Comedians</Link>
            <Link to="/shows">Shows</Link>
            <Link to="/Partnerships">Partnerships</Link>
            <Link to="/contact">Contact</Link>
          </nav>

          <div className="footer-column">
            <span className="footer-label">Follow</span>
            <div className="footer-social">
              <a
                href="https://www.facebook.com/profile.php?id=61552184496950"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebookF aria-hidden="true" />
              </a>
              <a
                href="https://www.instagram.com/lrmmanagement"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram aria-hidden="true" />
              </a>
              <a
                href="https://www.tiktok.com/@lrmmanagement"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok"
              >
                <FaTiktok aria-hidden="true" />
              </a>
              <a
                href="https://www.threads.net/@lrmmanagement"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Threads"
              >
                <FaThreads aria-hidden="true" />
              </a>
            </div>
          </div>

          <div className="footer-column">
            <span className="footer-label">Inquiries</span>
            <a href="mailto:info@lrmmanagement.com" className="footer-email">
              info@lrmmanagement.com
            </a>
            <Link to="/Partnerships" className="footer-cta-link">
              Brand partnerships &rarr;
            </Link>
          </div>
        </div>

        <div className="footer-divider" aria-hidden="true" />

        <div className="footer-bottom">
          <p className="footer-copyright">
            &copy; {year} LRM Management. All rights reserved.
          </p>
          <a
            href="https://eugenioespinoza.com"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-credit"
          >
            Developed by Eugenio Espinoza
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
